"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "foglianise": {
    "42f0003f": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "skipSearch": false
    }],
    "acquara": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "889ad41d": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "skipSearch": false
    }],
    "badia": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "99107f44": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "skipSearch": false
    }],
    "barassano": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "52b6ebcb": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "skipSearch": false
    }],
    "cautani": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "43034fb5": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "skipSearch": false
    }],
    "chiariella": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bec5545d": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "skipSearch": false
    }],
    "cienzi": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "78c953a3": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "skipSearch": false
    }],
    "golini": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "118efd15": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "skipSearch": false
    }],
    "lannilli": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d59bb809": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "skipSearch": false
    }],
    "leschito": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "65aaec68": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "skipSearch": false
    }],
    "massaria-nuova": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "de6f87f6": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "skipSearch": false
    }],
    "oliveto": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1db3e55e": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "skipSearch": false
    }],
    "palazzo": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c9fc8a13": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "skipSearch": false
    }],
    "posto": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "69487ef5": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "skipSearch": false
    }],
    "sala": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3e905628": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "skipSearch": false
    }],
    "sirignano": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8db5c7e6": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "skipSearch": false
    }],
    "torre-verzillo": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a8ffcc7d": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "skipSearch": false
    }],
    "trescene": [{
      "hkey": "8a2381d8",
      "slug": "foglianise",
      "name": "Foglianise",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;